import { Spin } from "antd";
import { useState } from "react";
import { UseApiCallV2 } from "hooks";
import { OnCollapseIcon } from "pages/m2c-simulation/icons";
import {
  DraggableContext,
  SupportTicketsHeader,
  TicketsSearchFilter,
} from "./components";
import { ConditionalRenderer } from "components";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styles from "./styles.module.scss";
import { UseApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-api-call";

export default function SupportTickets() {
  const [searchVal, setSearchVal] = useState<string>("");
  const [expanded, setExpanded] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedIssueType, setSelectedIssueType] = useState("all");

  const {
    data: ticketsData,
    isLoading,
    refetch: refetchTicketsData,
  }: any = UseApiCallV2({
    url: "/get_all_tickets",
    method: "POST",
    paramsData: {
      token: "null",
    },
  });

  const { data: allTickets, isLoading: ticketsLoading } =
    UseApiCallInternalDashboard({
      isCvUser: false,
      url: "support/tickets",
      method: "POST",
      // body: {
      //   today: true,
      // },
    });

  let tickets = ticketsData;
  const handleChangeAccordian =
    (panel: any) => (event: any, isExpanded: any) => {
      setExpanded(isExpanded ? panel : "");
    };
  if (searchVal) {
    tickets = tickets?.filter((item: any) =>
      item.topic?.toLowerCase().includes(searchVal)
    );
  }

  if (selectedStatus !== "all" && Array.isArray(tickets)) {
    tickets = tickets?.filter((item: any) => item.status === selectedStatus);
  }
  if (selectedIssueType !== "all" && Array.isArray(tickets)) {
    tickets = tickets?.filter(
      (item: any) => item.issueType === selectedIssueType
    );
  }
  function getFilteredTickets({ totalTickets, key }: any) {
    return totalTickets?.filter((item: any) => item.sportsName === key);
  }

  const golfTickets = getFilteredTickets({
    totalTickets: tickets,
    key: "golf",
  });
  const baseballTickets = getFilteredTickets({
    totalTickets: tickets,
    key: "baseball",
  });
  const athleticsTickets = getFilteredTickets({
    totalTickets: tickets,
    key: "athletics",
  });

  function handleChangeTicketPreference(data: any) {
    setSelectedStatus(data?.value);
  }
  function handleChangeIssueType(data: any) {
    setSelectedIssueType(data?.value);
  }

  return (
    <section className={styles.supportTickets}>
      <ConditionalRenderer condition={isLoading}>
        <div className={styles.loading}>
          <Spin />
        </div>
      </ConditionalRenderer>

      <TicketsSearchFilter
        setSearchVal={setSearchVal}
        searchVal={searchVal}
        handleChangeTicketPreference={handleChangeTicketPreference}
        handleChangeIssueType={handleChangeIssueType}
      />

      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChangeAccordian("panel1")}
      >
        <AccordionSummary
          expandIcon={<OnCollapseIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            "&.Mui-expanded": {
              minHeight: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              // margin from https://github.com/mui-org/material-ui/blob/cc0e2ab63e8be9ec4d51a49bfde17ef28fc77b9c/packages/mui-material/src/AccordionSummary/AccordionSummary.js#L64-L64
              margin: "6px 0",
            },
          }}
        >
          <SupportTicketsHeader
            totalIssues={golfTickets?.length}
            circleLabel="MG"
            title="Motion2Coach Golf"
            color="#006AB3"
          />
        </AccordionSummary>
        <AccordionDetails style={{ maxHeight: "440px", overflowY: "auto" }}>
          <ConditionalRenderer condition={tickets}>
            <DraggableContext
              tickets={golfTickets}
              refetchTicketsData={refetchTicketsData}
            />
          </ConditionalRenderer>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChangeAccordian("panel2")}
      >
        <AccordionSummary
          expandIcon={<OnCollapseIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          sx={{
            "&.Mui-expanded": {
              minHeight: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              // margin from https://github.com/mui-org/material-ui/blob/cc0e2ab63e8be9ec4d51a49bfde17ef28fc77b9c/packages/mui-material/src/AccordionSummary/AccordionSummary.js#L64-L64
              margin: "6px 0",
            },
          }}
        >
          <SupportTicketsHeader
            totalIssues={baseballTickets?.length}
            circleLabel="MB"
            title="Motion2Coach Baseball"
            color="#FBB900"
          />
        </AccordionSummary>
        <AccordionDetails style={{ maxHeight: "450px", overflowY: "auto" }}>
          <ConditionalRenderer condition={tickets}>
            <DraggableContext
              tickets={baseballTickets}
              refetchTicketsData={refetchTicketsData}
            />
          </ConditionalRenderer>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChangeAccordian("panel3")}
      >
        <AccordionSummary
          expandIcon={<OnCollapseIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          sx={{
            "&.Mui-expanded": {
              minHeight: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              // margin from https://github.com/mui-org/material-ui/blob/cc0e2ab63e8be9ec4d51a49bfde17ef28fc77b9c/packages/mui-material/src/AccordionSummary/AccordionSummary.js#L64-L64
              margin: "6px 0",
            },
          }}
        >
          <SupportTicketsHeader
            totalIssues={athleticsTickets?.length}
            circleLabel="MA"
            title="Motion2Coach Athletics"
            color="#78BA2C"
          />
        </AccordionSummary>
        <AccordionDetails style={{ maxHeight: "450px", overflowY: "auto" }}>
          <ConditionalRenderer condition={tickets}>
            <DraggableContext
              tickets={athleticsTickets}
              refetchTicketsData={refetchTicketsData}
            />
          </ConditionalRenderer>
        </AccordionDetails>
      </Accordion>

      {/* <Tickets ticketsData={[1, 2, 3]} /> */}
    </section>
  );
}
